import reportGuids from './reportGuids';
import CO2Strategy from './strategies/cO2Strategy.js';
import DashboardSubmeterStrategy from './strategies/dashboardSubmeterStrategy.js';
import DashboardUtilityDataStrategy from './strategies/dashboardUtilityDataStrategy.js';
import DashboardUtilityElectricityStrategy from './strategies/dashboardUtilityElectricityStrategy.js';
import DefaultStrategy from './strategies/defaultStrategy.js';
import EndUseStrategy from './strategies/endUseStrategy';
import ERCOT4CPStrategy from './strategies/ERCOT4CPStrategy.js';
import HourlyEndUseStrategy from './strategies/hourlyEndUseStrategy.js';
import IAQStrategy from './strategies/IAQStrategy.js';
import IAQV3Strategy from './strategies/IAQV4Strategy.js';
import MonthlyUtilityStrategy from './strategies/monthlyUtilityStrategy.js';
import NewIAQStrategy from './strategies/NewIAQStrategy.js';
import PowerQualityStrategy from './strategies/powerQualityStrategy.js';
import PowerQualityV3Strategy from './strategies/powerQualityV3Strategy.js';
import RealTime from './strategies/realTime.js';
import SensorStrategy from './strategies/sensorStrategy.js';
import SolarStrategy from './strategies/solarStrategy.js';
import UtilityForecast from './strategies/utilityForecast.js';
import EndUseBreakdown from './strategies/endUseBreakdownStrategy.js';
import ThermostatStrategy from './strategies/thermostatStrategy.js';

const getPowerBiReportStrategy = async function (
  reportName,
  container,
  embedConfiguration
) {
  switch (reportName) {
    case reportGuids.CO2:
      await CO2Strategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.DashboardUtilityData:
      await DashboardUtilityDataStrategy.embedAndSlice(
        container,
        embedConfiguration,
        reportGuids
      );
      break;
    case reportGuids.DashboardUtilityElectricity:
      await DashboardUtilityElectricityStrategy.embedAndSlice(
        container,
        embedConfiguration,
        reportGuids
      );
      break;
    case reportGuids.DashboardSubmeterV2:
      await DashboardSubmeterStrategy.embedAndSlice(
        container,
        embedConfiguration,
        reportGuids
      );
      break;
    case reportGuids.EndUse:
      await EndUseStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.EndUseBreakdown:
      await EndUseBreakdown.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.HourlyEndUse:
      await HourlyEndUseStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.IndoorAirQuality:
      await IAQStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.IndoorAirQualityNew:
      await NewIAQStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.IndoorAirQualityV4:
      await IAQV3Strategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.MonthlyUtility:
      await MonthlyUtilityStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.PowerQuality:
      await PowerQualityStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.PowerQualityV3:
      await PowerQualityV3Strategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.Sensor:
      await SensorStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.Solar:
      await SolarStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.UtilityForecast:
      await UtilityForecast.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.RealTime:
      await RealTime.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.ERCOT4CP:
      await ERCOT4CPStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.Thermostat:
      await ThermostatStrategy.embedAndSlice(container, embedConfiguration);
      break;
    case reportGuids.Benchmark:
    case reportGuids.LoadUsage:
    case reportGuids.NOC:
    case reportGuids.SiteStartTimeAnalytics:
    case reportGuids.TenentBilling:
    case reportGuids.TenantBillingWideFormat:
    default:
      await DefaultStrategy.embedAndSlice(container, embedConfiguration);
      break;
  }
};

export default {
  getPowerBiReportStrategy,
};
